// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TpxESlnnylE5Xq {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
.FG4XK1qY5gr6r6 {
  display: flex;
  justify-content: center;
}
.knEr93RcSuY4XL {
  flex: 1 1 auto;
  min-height: calc(100vh - 80px);
  padding-bottom: var(--ds-space-400, 32px);
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.g7oEZIMer88IKy {
  display: flex;
  justify-content: center;
  padding: var(--ds-space-400, 32px);
}
.u_ulZpLzRpw7WT {
  font-style: italic;
}
.AhTp0AGxRfVGM9 {
  flex-grow: 1;
  min-width: 320px;
  max-width: 800px;
  padding: var(--ds-space-400, 32px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
}
.aMJ_Sx58NfwOzX {
  display: flex;
  align-items: center;
  justify-content: center;
}
.H6H7_rWb3Z9frj {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--ds-space-300, 24px);
  padding-bottom: var(--ds-space-200, 16px);
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.H6H7_rWb3Z9frj .YasM5jLWhP2lAp {
  margin: var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
.ZWKMP46ZJ7cCbc {
  padding-top: var(--ds-space-200, 16px);
  border-top: 1px solid var(--ds-border, #091e4224);
}
.ZWKMP46ZJ7cCbc button {
  margin-left: var(--ds-space-100, 8px);
}
.zZ6Jnsvf11RMWV {
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 900px) {
  .AhTp0AGxRfVGM9 {
    padding: var(--ds-space-200, 16px);
  }
}
.gVs1h2UV17cVEw label {
  display: block;
  margin-bottom: var(--ds-space-050, 4px);
}
.txNPEXThNPpJ2Q {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: var(--ds-space-250, 20px);
  margin-bottom: var(--ds-space-100, 8px);
}
.S4Zq0eGdnqQjQL {
  width: 36px;
  height: 36px;
  margin: var(--ds-space-025, 2px) var(--ds-space-0, 0) var(--ds-space-0, 0) 10px;
  padding: var(--ds-space-0, 0);
}
.gvHZLuNHCdw09_ {
  flex-grow: 1;
  margin-top: 11px;
  margin-left: 45px;
}
._SUqfpKlH3RRgh {
  margin-top: var(--ds-space-0, 0);
}
.aMJ_Sx58NfwOzX {
  display: flex;
  justify-content: center;
  width: 100%;
}
@media only screen and (max-width: 900px) {
  .txNPEXThNPpJ2Q {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .gvHZLuNHCdw09_ {
    max-width: 400px;
    margin-left: var(--ds-space-0, 0);
    color: var(--ds-text-subtle, #44546f);
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `TpxESlnnylE5Xq`,
	"flexAndCenter": `FG4XK1qY5gr6r6`,
	"body": `knEr93RcSuY4XL`,
	"navigationAndContent": `g7oEZIMer88IKy`,
	"learnMoreSubtle": `u_ulZpLzRpw7WT`,
	"content": `AhTp0AGxRfVGM9`,
	"spinnerContainer": `aMJ_Sx58NfwOzX`,
	"header": `H6H7_rWb3Z9frj`,
	"title": `YasM5jLWhP2lAp`,
	"footer": `ZWKMP46ZJ7cCbc`,
	"formFooter": `zZ6Jnsvf11RMWV`,
	"formElements": `gVs1h2UV17cVEw`,
	"formSection": `txNPEXThNPpJ2Q`,
	"copyBtn": `S4Zq0eGdnqQjQL`,
	"inputDescription": `gvHZLuNHCdw09_`,
	"label": `_SUqfpKlH3RRgh`
};
export default ___CSS_LOADER_EXPORT___;
